/**
 * Browser-tab suffix from the app name published by the root Blade view.
 */
export function formatBrowserTitle(title: string): string {
  const appName = configuredAppName();
  const pageTitle = title.trim();

  return pageTitle === "" ? appName : `${pageTitle} - ${appName}`;
}

function configuredAppName(): string {
  if (typeof document !== "undefined") {
    const fromConfig = document
      .querySelector('meta[name="app-name"]')
      ?.getAttribute("content")
      ?.trim();

    if (fromConfig) {
      return fromConfig;
    }
  }

  const fromEnv = import.meta.env.VITE_APP_NAME;

  return typeof fromEnv === "string" && fromEnv.trim() !== ""
    ? fromEnv.trim()
    : "NEO";
}
